import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import NoData from '../../../components/common/NoData';
import { getFAQ } from '../../../services/userService';

function Faq() {
    const [searchTerm, setSearchTerm] = useState('');
    const [faqList, setFaqList] = useState([]);
    const [readFaqIds, setReadFaqIds] = useState([]); // Track opened FAQs
    const [openFaqIds, setOpenFaqIds] = useState([]); // Track which FAQs are currently open

    useEffect(() => {
        fetchFaqs();
    }, []);

    const fetchFaqs = async () => {
        try {
            const response = await getFAQ();
            if (response.success && response.data?.response) {
                setFaqList(response.data.response);
            } else {
                setFaqList([]);
                console.error('Failed to fetch FAQs:', response?.error_msg || 'Unknown error');
            }
        } catch (error) {
            console.error('Error fetching FAQs:', error);
        }
    };

    const filteredFaqs = faqList.filter(
        (faq) =>
            faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
            faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleToggle = (faqId) => {
        setOpenFaqIds(prev => 
            prev.includes(faqId) 
                ? prev.filter(id => id !== faqId)
                : [...prev, faqId]
        );
        if (!readFaqIds.includes(faqId)) {
            setReadFaqIds((prev) => [...prev, faqId]);
        }
    };

    return (
        <div className="flex flex-col py-0 md:py-4 px-0 md:px-3 pt-3 md:pt-0">
            <div className="w-full">
                <h3 className="mb-4 font-semibold text-lg sm:text-2xl md:text-3xl">Frequently Asked Questions</h3>
            </div>

            <div className="w-full md:w-1/3 mb-4">
                <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 mb-4"
                    placeholder="Search FAQ..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <div className="w-full">
                {filteredFaqs.length === 0 ? (
                    <NoData message="No FAQs found." />
                ) : (
                    <div className="space-y-3">
                        {filteredFaqs.map((faq, index) => {
                            const isRead = readFaqIds.includes(faq.id);
                            const isOpen = openFaqIds.includes(faq.id);
                            return (
                                <div
                                    className={`border border-gray-200 rounded-lg mb-3 ${isRead ? 'bg-gray-100 border-t-2 border-t-primary' : 'bg-white'}`}
                                    key={faq.id}
                                >
                                    <h2>
                                        <button
                                            className={`w-full text-left p-4 font-semibold flex justify-between items-center ${isRead ? 'text-primary' : 'text-gray-800'} hover:bg-gray-50 rounded-t-lg transition-colors`}
                                            type="button"
                                            onClick={() => handleToggle(faq.id)}
                                        >
                                            <span>{`${index + 1}. ${faq.question}`}</span>
                                            <Icon icon={isOpen ? "mdi:chevron-up" : "mdi:chevron-down"} className="ml-2" />
                                        </button>
                                    </h2>
                                    {isOpen && (
                                        <div className="p-4 pt-0 text-gray-600 border-t border-gray-200">
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Faq;
